import React from 'react';

import { Layout } from '@components/Layout';
import { useGenerateStatusError } from '@hooks/queries/useGenerateError';

export const TestStatusError404: React.FC = () => {
  const generateError = useGenerateStatusError(404);

  return (
    <Layout
      title="TestStatusError404"
      loading={generateError.isLoading}
      errors={[generateError.error]}
    >
      {null}
    </Layout>
  );
};
